import {
  GetUserExperimentBranchQuery,
  GetUserExperimentBranchQueryVariables
} from '@data/__generated__/types.experiments'
import getDeviceId from '@helpers/auth/getDeviceId'
import useInitialData from '@page-components/Layout/useInitialData'
import {useApolloQuery as useQuery} from 'apollo-hooks'
import gql from 'graphql-tag'

import useUserId from './useUserId'

export default function useExperiment(
  experimentId: string,
  {partial = true}: {partial?: boolean} = {}
) {
  const {website} = useInitialData()
  const deviceId = getDeviceId()
  const userId = useUserId()

  // Hacky trick to disable apollo validation since this uses the experiments client

  const {getUserExperimentBranch} = useQuery<
    GetUserExperimentBranchQuery,
    GetUserExperimentBranchQueryVariables
  >({
    errorPolicy: 'ignore',
    clientName: 'experiments',
    query: gql`
      query getUserExperimentBranch(
        $experimentId: String!
        $deviceId: String!
        $websiteId: String
        $userId: String
        $countryCode: String
      ) {
        getUserExperimentBranch(
          experimentId: $experimentId
          websiteId: $websiteId
          userId: $userId
          deviceId: $deviceId
          countryCode: $countryCode
        ) {
          branchName
          createdAt
        }
      }
    `,
    variables: {
      experimentId,
      websiteId: website?._id,
      userId,
      deviceId,
      countryCode: website?.countryCode
    },
    partial,
    fetchPolicy: 'cache-first'
  })

  return getUserExperimentBranch?.branchName
}

export const withExperiment = (
  experimentId: string,
  Component: React.ComponentClass<{
    experimentBranchName?: string
  }>
) => {
  // eslint-disable-next-line react/display-name
  return props => {
    const branchName = useExperiment(experimentId)

    return <Component {...props} experimentBranchName={branchName} />
  }
}
